import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import Swal from 'sweetalert2';
import { RestClientService } from '../../../../core/service/rest-client.service';
import { AuthService } from '../../../../core/service/auth.service';
import { UtilitiesService } from '../../../../core/service/utilities.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { BenefInfoComponent } from '@shared/components/benef-info/benef-info.component';
import { FileUploadComponent } from '@shared/components/file-upload/file-upload.component';
import { ScrollSearchMedocPrestaComponent } from '@shared/components/scroll-search-medoc-presta/scroll-search-medoc-presta.component';
import { PrestationInfoComponent } from '@shared/components/prestation-info/prestation-info.component';
import { SearchMdicamentProComponent } from '@shared/components/search-mdicament-pro/search-mdicament-pro.component';
import { SearchExamenLaboComponent } from '@shared/components/search-examen-labo/search-examen-labo.component';
import { SearchFormComponent } from '@shared/components/search-form/search-form.component';
import { ScrollSearchActeComponent } from '@shared/components/scroll-search-acte/scroll-search-acte.component';
import { MoneyFormatPipe } from '../../../../shared/pipe/money-format.pipe';

@Component({
  selector: 'app-form-pres-procrea',
  imports: [
    CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule,
    BenefInfoComponent, MatFormFieldModule, MatInputModule, MatSelectModule,
    MatOptionModule, MatIconModule, FileUploadComponent, MatCheckboxModule,
    MatRadioModule, MatDatepickerModule, MatButtonModule, OwlDateTimeModule,
    OwlNativeDateTimeModule, MatSlideToggleModule, ScrollSearchMedocPrestaComponent,
    PrestationInfoComponent, SearchMdicamentProComponent, SearchExamenLaboComponent,
    SearchFormComponent, ScrollSearchActeComponent, MoneyFormatPipe,
  ],
  templateUrl: './form-pres-procrea.component.html',
  styleUrl: './form-pres-procrea.component.scss',
})
export class FormPresProcreaComponent {
  @Output() onSendBenefItem = new EventEmitter<any>();
  @Output() onClosePrescriptionMedocModal = new EventEmitter<any>();
  @Output() onGoToTab = new EventEmitter<any>();
  @Output() onPrescriptionSaved = new EventEmitter<void>();
  @Input() matricule: any;
  @Input() refreshTriggerOrdonnance!: boolean;

  user: any = {};
  isLoading: boolean | undefined;
  isConsultationSuccess = false;
  input_value: any;
  input_option = 'MAT';
  searchPlaceHolder = 'Entrez numéro matricule';

  itemBeneficiare: any = {};
  itemConsultation: any = {};
  dossierActif: any = {};
  prestationActive: any = {};
  beneficiaireAutOselect: any;
  currentFile: any;
  fileName1: any;

  itemToSave: any = {};
  itemsElement: any[] = [];
  itemsAffection: any[] = [];
  itemsGarantie: any[] = [];
  itemsPraticien: any[] = [];
  itemsActe: any[] = [];
  selectedActeItem: any = null;
  garantie_id: any;
  loadingActes = false;
  loadingTarif = false;

  constructor(
    private restClient: RestClientService,
    private router: Router,
    private authService: AuthService,
    private utilities: UtilitiesService,
  ) {
    this.user = this.authService.getCurrentUser();
    this.beneficiaireAutOselect = this.authService.getActiveBeneficiaire();
    this.getItemsAffection();
    this.getItemsGarantie();
    this.getItemsPraticien();
  }

  getItemsAffection() {
    this.restClient.post('affection/getByCriteria', { index: 0, size: 1000, data: {} }).subscribe(
      (res: any) => {
        this.itemsAffection = (res && !res['hasError'] && res['items']) ? res.items : [];
      },
      () => { this.itemsAffection = []; }
    );
  }

  getItemsGarantie() {
    this.restClient.post('garantie/getByCriteria', { index: 0, size: 1000, data: {} }).subscribe(
      (res: any) => {
        if (res && !res['hasError'] && res['items']) {
          this.itemsGarantie = res.items;
          this.garantie_id = this.itemsGarantie.find((ig: any) => ig.codification == 'AMP')?.id ?? null;
          this.getItemsActe();
          if (this.matricule) {
            this.input_value = this.matricule;
            this.searcheBenef();
          }
        } else {
          this.itemsGarantie = [];
        }
      },
      () => { this.itemsGarantie = []; }
    );
  }

  getItemsActe() {
    if (!this.garantie_id) return;
    this.loadingActes = true;
    this.restClient.post('acte/getByCriteria', { index: 0, size: 1000, data: { garantie_id: this.garantie_id } }).subscribe(
      (res: any) => {
        this.loadingActes = false;
        this.itemsActe = res?.items ?? [];
      },
      () => { this.loadingActes = false; }
    );
  }

  getItemsPraticien() {
    this.restClient.post('praticien/searchByPrestataire', { index: 0, size: 1000, data: {} }).subscribe(
      (res: any) => {
        if (res && !res['hasError'] && res['items']) {
          this.itemsPraticien = res.items.map((ip: any) => ({
            ...ip,
            full_name: `${ip.nom} ${ip.prenom} (${ip.specialite_libelle})`,
          }));
        } else {
          this.itemsPraticien = [];
        }
      },
      () => { this.itemsPraticien = []; }
    );
  }

  onAddItemToList(): void {
    if (!this.selectedActeItem || !this.selectedActeItem.id) return;
    if (this.itemsElement.some((ie: any) => ie.acte_id == this.selectedActeItem.id)) {
      this.utilities.showSweetNotification('Cet acte est déjà dans la liste', 'error');
      return;
    }
    const newItem = {
      is_entente_prealable: this.selectedActeItem.is_entente_prealable,
      is_exclu: this.selectedActeItem.is_exclu,
      acte_id: this.selectedActeItem.id,
      acte_libelle: this.selectedActeItem.libelle,
      quantite: 1,
      garantie_id: this.selectedActeItem.garantie_id,
      is_referred: this.selectedActeItem.is_referred,
      montant: 0,
      part_patient: 0,
      part_assurance: 0,
    };
    this.selectedActeItem = null;
    this.getTarifActeForItem(newItem);
  }

  getTarifActeForItem(item: any): void {
    const request = {
      index: 0, size: 1000,
      data: {
        acte_id: item.acte_id,
        matricule: this.itemBeneficiare?.matricule,
        prestataire_codification: this.user?.prestataire_codification,
      },
    };
    this.loadingTarif = true;
    this.restClient.post('bareme/getTarifActeOnly', request).subscribe(
      (res: any) => {
        this.loadingTarif = false;
        if (res && !res['hasError'] && res['item']) {
          const t = res.item;
          item.montant_unitaire = t.montant;
          item.part_patient_unitaire = t.part_patient_net;
          item.part_assurance_unitaire = t.part_assurance_net;
          item.montant = t.montant * (item.quantite || 1);
          item.part_patient = t.part_patient_net * (item.quantite || 1);
          item.part_assurance = t.part_assurance_net * (item.quantite || 1);
          item.taux_applicable = t.taux_applicable;
          item.prestation_acte_id = t.prestation_acte_id;
          this.itemsElement.unshift(item);
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
        }
      },
      (error) => {
        this.loadingTarif = false;
        this.utilities.showSweetNotification(error, 'error');
      }
    );
  }

  onQuantiteChange(item: any): void {
    if (!item.quantite || item.quantite < 1) item.quantite = 1;
    item.montant = (item.montant_unitaire || 0) * item.quantite;
    item.part_patient = (item.part_patient_unitaire || 0) * item.quantite;
    item.part_assurance = (item.part_assurance_unitaire || 0) * item.quantite;
  }

  confirmSaveItem(data: any) {
    Swal.fire({
      title: 'Prescription procréation médicalement assistée',
      text: 'Souhaitez-vous poursuivre cette action?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) { this.saveItems(); }
    });
  }

  saveItems() {
    this.isConsultationSuccess = false;
    if (this.itemsElement && this.itemsElement.length) {
      this.itemsElement.forEach((im: any) => {
        im.affection_id = this.itemToSave.affection_id;
        im.matricule = this.itemBeneficiare.matricule;
        im.beneficiaire_id = this.itemBeneficiare.id;
        im.dossier_id = this.dossierActif?.id;
        im.garantie_id = this.garantie_id;
        im.renseignement_clinique = this.itemToSave.renseignement_clinique;
        im.prestataire_id = this.user.prestataire_id;
        im.praticien_id = this.itemToSave.praticien_id;
      });
    }
    if (this.currentFile && Object.keys(this.currentFile).length) {
      this.itemConsultation.file_data = this.currentFile;
    }
    const request = {
      file_data: this.currentFile && Object.keys(this.currentFile).length ? this.currentFile : '',
      datas: [...this.itemsElement],
    };
    this.restClient.post('prescriptionActe/create', request).subscribe(
      (res: any) => {
        if (res && !res['hasError']) {
          this.isConsultationSuccess = true;
          this.utilities.showSweetNotification(res['status']['message'], 'succes');
          this.itemsElement = [];
          this.itemToSave = {};
          this.onPrescriptionSaved.emit();
        } else {
          this.isConsultationSuccess = false;
          this.utilities.showSweetNotification(res['status']['message'], 'error');
        }
        this.onClosePrescriptionMedocModal.emit('hide');
      },
      (error) => {
        this.isConsultationSuccess = false;
        this.utilities.showSweetNotification(error, 'error');
      }
    );
  }

  searcheBenef(activeBenefMatricule?: any) {
    if (!this.input_value && activeBenefMatricule) {
      this.input_value = activeBenefMatricule;
    }
    if (!this.input_value) return;
    this.isLoading = true;
    this.itemBeneficiare = {};
    const form = this.input_option == 'CMU' ? { numero_cnam: this.input_value } : { matricule: this.input_value };
    this.restClient.post('beneficiaire/search', { is_required_dossier: true, data: form }).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError']) {
          this.itemBeneficiare = res.item;
          this.dossierActif = res.item.dossier_actif;
          this.prestationActive = res.item.prestation_active;
          this.authService.setActiveBeneficiaire(res.item);
          this.onSendBenefItem.emit(this.itemBeneficiare);
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
          this.itemBeneficiare = {};
        }
      },
      (error) => {
        this.isLoading = false;
        this.utilities.showSweetNotification(error, 'error');
        this.itemBeneficiare = {};
      }
    );
  }

  onSetUserInfo(event: any) {
    if (event.id) {
      this.itemBeneficiare = event;
      this.dossierActif = event.dossier_actif;
      this.authService.setActiveBeneficiaire(event);
      this.beneficiaireAutOselect = this.itemBeneficiare;
    } else {
      this.authService.setActiveBeneficiaire({});
      this.beneficiaireAutOselect = {};
    }
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];
      this.fileName1 = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        const fileBase64 = data.split(',')[1];
        this.currentFile = { fileBase64, fileName, extension, typeDocument: 'custom type' };
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['matricule'] && this.matricule && this.itemsGarantie?.length) {
      this.input_value = this.matricule;
      this.searcheBenef(this.matricule);
    }
    if (changes['refreshTriggerOrdonnance'] && changes['refreshTriggerOrdonnance'].currentValue) {
      const activeBeneficiaire = this.authService.getActiveBeneficiaire();
      if (activeBeneficiaire.matricule) {
        this.input_value = activeBeneficiaire.matricule;
        this.searcheBenef(activeBeneficiaire.matricule);
      }
    }
  }

  onChangeInputMode() {
    this.input_value = '';
    this.searchPlaceHolder = this.input_option == 'MAT' ? 'Entrez numéro matricule' : 'Entrez numéro cnam';
  }
}
